<div class="contract-state">
    <!--SVG-->
    <ng-container [ngSwitch]="svg">
        <lib-generated-svg *ngSwitchCase="Svgs.ContractGenerated"></lib-generated-svg>
        <lib-for-upload-svg *ngSwitchCase="Svgs.ForUpload"> </lib-for-upload-svg>
        <lib-done-outline-svg *ngSwitchCase="Svgs.DoneOutline"></lib-done-outline-svg>
        <lib-generating-svg *ngSwitchDefault></lib-generating-svg>
    </ng-container>
    <br>
    <!--DOWNLOAD ICON-->
    <ng-template [ngIf]="hasDownloadIcon">
        <button type="button" class="btn btn-light btn-download">
            <lib-save-svg ></lib-save-svg> Descargar Carta Compromiso
        </button>
        
    </ng-template>

     <!--TITLE-->
    <p class="title mt-5">{{title}}</p>
     <!--SUBTITLE-->
    <p class="sub-title" *ngIf="hasSubtitle">{{subtitle}}</p>
    <!--BUTTON-->
    <lib-button-1 *ngIf="hasButton"
        [buttonText]="buttonText"
        (buttonPressed)="onClick()">
    </lib-button-1>
    <!--LOADER-->
    <ng-template [ngIf]="hasLoader">
        <lib-loader-svg></lib-loader-svg>
    </ng-template>
</div>
